import createStore from 'framework/vuex/store';


/**
 * Initialize vuex
 * @param {Object} root - The app's root component
 */
function init(root) {
    // Append a store to the root instance
    root.store = createStore({ strict: process.env.NODE_ENV !== 'production' });
}

export default init;
